import React, { useContext, useEffect, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { CartContext } from "./CartContext";
import Header from "./Header";
import Footer from "./Footer";
import "../css/paysuccess.css";

const PaymentStatus = () => {
  const [searchParams] = useSearchParams();
  const { clearCart } = useContext(CartContext);
  const isSuccess = searchParams.get("state") === "success";
  const hasClearedCart = useRef(false);

  useEffect(() => {
    if (isSuccess && !hasClearedCart.current) {
      hasClearedCart.current = true;
      clearCart();
    }
  }, [clearCart, isSuccess]);

  return (
    <>
      <Header />
      <main className="successDiv">
        <div className="success-container">
          <div className={`modal-content ${isSuccess ? "is-success" : "is-cancel"}`}>
            <div className="payment-status-icon">
              <FontAwesomeIcon icon={isSuccess ? faCheck : faXmark} />
            </div>
            <h1>{isSuccess ? "Payment successful" : "Payment cancelled"}</h1>
            <p>{isSuccess
              ? "Thank you. Your order has been received and is being reviewed."
              : "Your payment was not completed. No order has been placed."}</p>
            <Link className="payment-status-link" to={isSuccess ? "/shop" : "/checkout"}>
              {isSuccess ? "Continue shopping" : "Return to checkout"}
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default PaymentStatus;
